import React, { useEffect, useState } from 'react';

import { useAuth } from 'context/auth-context';
import usePayrollEvents from 'hooks/payrollEvent/usePayrollEvents';
import { PayrollEventRetrieve } from 'types';

import PayrollReportPageHeader from './components/PayrollReportPageHeader';
import PayrollReportTable from './components/PayrollReportTable';

const PayrollReport = (): JSX.Element => {
  const { hasPerm, session } = useAuth();
  const payrollPerm = hasPerm('PayrollMutate');

  const [payrollPeriod, setPayrollPeriod] = useState<string | null>(null);
  const [ascending, setAscending] = useState(true);
  const [ordering, setOrdering] = useState('date');
  const [tableData, setTableData] = useState<PayrollEventRetrieve[]>([]);

  const { data, hasNextPage, fetchNextPage, isSuccess, isError, isLoading, isFetchingNextPage } =
    usePayrollEvents({
      staffId: session?.staff?.staffId,
      payrollPeriod,
      limit: '10000',
      ordering: ascending ? ordering : `-${ordering}`,
      enabled: !!payrollPeriod,
    });

  const handleHeaderClick = (header: string): void => {
    setOrdering(header);
    setAscending(a => !a);
  };

  useEffect(() => {
    if (!isLoading && data) {
      const flatData = data.pages.map(page => page.data.results).flat();
      setTableData(flatData);
    }
  }, [isLoading, data, setTableData]);

  return (
    <>
      <PayrollReportPageHeader
        staffName={session?.staff?.fullName}
        staffId={session?.staff?.staffId}
        permission={payrollPerm}
        payrollPeriod={payrollPeriod}
        setPayrollPeriod={setPayrollPeriod}
        tableData={tableData}
        isSuccess={isSuccess}
        isError={isError}
        isLoading={isLoading}
      />

      <PayrollReportTable
        tableData={tableData}
        isSuccess={isSuccess}
        isError={isError}
        isLoading={isLoading}
        isFetchingNextPage={isFetchingNextPage}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        ascending={ascending}
        handleHeaderClick={handleHeaderClick}
        ordering={ordering}
      />
    </>
  );
};

export default PayrollReport;
